import Vue from "vue"
/* import pagesApi from "../../api/pages" */
import utilsApi from "../../api/utils"
const initialObject = {
  site: undefined,
  _id: undefined,
  media: undefined,
  breadcrumbs: false,
  header_skin: undefined,
  body_skin: undefined,
  tags: undefined,
  name: undefined,
  title: undefined,
  description: undefined,
  body: "",
  status: undefined,
  nofollow: false,
  noindex: false,
  nositemap: false,
  page_atributes: undefined,
  page_layout: undefined,
  createdAt: undefined,
  updatedAt: undefined,
  slug: undefined,
  locale_id: undefined,
  page: undefined,
  __v: undefined
}
// general state for the site
const initialState = {
  pages: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  pages: (state) => state.pages,
  pagesIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  pagesError: (state) => state.error,
  pages_Object: (state) => state.object,
  pages_isNew: (state) => state.isNew,
  pages_selected: (state) => state.selected
}
const actions = {
  async DELETE_pages({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("pages", object)
    if (apiResponse != null) {
      //commit("PAGES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_pages", state.page)
      return true
    } else {
      commit("PAGES_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_pages({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_pages", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_pages", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_pagesState({ commit }, payload) {
    commit("SET_pages", payload)
    return true
  },
  async UPDATE_pages({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.updateObject("pages", object)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PAGES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_pages", state.page)
      return true
    } else {
      commit("PAGES_ERROR")
      return false
    }
  },
  async CREATE_pages({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("pages", object)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("SET_pages", {
        param: "object",
        value: apiResponse.page
      })
      dispatch("FETCH_PAGE_pages", state.page)
      return true
    } else {
      commit("PAGES_ERROR")
      return false
    }
  },
  async FETCH_pages({ commit }) {
    let apiResponse = await utilsApi.getObjects("pages")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PAGES_SETTING", apiResponse)
      return true
    } else {
      commit("PAGES_ERROR")
      return false
    }
  },

  async FETCH_PAGE_pages({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("pages", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("PAGES_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("PAGES_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_pages({ commit }, payload) {
    commit("SET_OBJECT_PAGE", payload)
    return true
  },
  CLEAN_OBJECT_pages({ commit }) {
    commit("SET_OBJECT_PAGE_INITIAL")
    return true
  },
  async CLEAN_STORE_pages({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_pages", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_pages({ commit }, payload) {
    commit("SET_SELECTED_PAGES", payload)
    return true
  }
}
const mutations = {
  PAGES_SETTING: (state, { pages, count = false, page }) => {
    //console.log(state)

    state.count = count || state.pages.length
    state.page = page || state.page
    state.pages = pages
    state.fetched = true
    state.error = false
  },
  PAGES_ERROR: (state) => {
    state.pages = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_PAGE: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_PAGE_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_PAGES: (state, selectedPages) => {
    state.selected = selectedPages
  },
  SET_pages: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
